module.exports = __webpack_public_path__ + "img/logout.12093c88.svg";